export const getGroupedOptionsObj = (optionsArr) => {
  let resultObj = {};

  const typeGroupMapObj = {
    address: { groupId: "addressGroup", groupLabel: "Adres" },
    email: { groupId: "emailGroup", groupLabel: "E-mail" },
    phone: { groupId: "phoneGroup", groupLabel: "Numer telefonu" },
  };

  optionsArr.forEach((optionObj) => {
    const typeGroupMapObjElement = typeGroupMapObj[optionObj.type];

    if (typeGroupMapObjElement) {
      const resultGroupObj = resultObj[typeGroupMapObjElement.groupId];

      if (resultGroupObj) {
        resultGroupObj.items.push(optionObj);
      } else {
        resultObj[typeGroupMapObjElement.groupId] = {
          label: typeGroupMapObjElement.groupLabel,
          items: [optionObj],
        };
      }
    }
  });

  resultObj.allOptionsGroup = { label: "Wszystkie", items: optionsArr };

  return resultObj;
};
